import "jquery-smooth-scroll";
import "jquery.easing";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function (e) {
  var $sectionQa = $(".section-qa");

  if ($sectionQa.length) {
    $(".section-qa .question").click(function () {
      $(this).toggleClass("more");
      $(this).parent().find(".answer").slideToggle();
    });
  }
});
